export var NavSections;
(function (NavSections) {
    NavSections["USERS"] = "USERS";
    NavSections["NOTIFICATIONVIEW"] = "NOTIFICATIONVIEW";
    NavSections["ORDERVIEW"] = "ORDERVIEW";
    NavSections["FIELDVIEW"] = "FIELDVIEW";
    NavSections["PAYLOADSEND"] = "PAYLOADSEND";
    NavSections["TAKEVIEW"] = "TAKEVIEW";
    NavSections["STOREVIEW"] = "STOREVIEW";
    NavSections["USEVIEW"] = "STOREVIEW";
    NavSections["EFFLUENT"] = "EFFLUENT";
    NavSections["PROVISION"] = "PROVISION";
    NavSections["CUSTOMERS"] = "CUSTOMERS";
    NavSections["IRRIGATORS"] = "IRRIGATORS";
    NavSections["SOILMOISTURE"] = "SOILMOISTURE";
    NavSections["STORAGE"] = "STORAGE";
    NavSections["HOMEPAGE"] = "HOMEPAGE";
    NavSections["WATERINFRASTRUCTURE"] = "WATERINFRASTRUCTURE";
    NavSections["WATERNETWORK"] = "WATERNETWORK";
    NavSections["COMPARISONVIEW"] = "COMPARISONVIEW";
    NavSections["LINK_TO_ENTITY"] = "LINK_TO_ENTITY";
    NavSections["PROPERTIESAREAS"] = "PROPERTIESAREAS";
    NavSections["SYSEVENTS"] = "SYSEVENTS";
    NavSections["PROPERTIES"] = "PROPERTIES";
    NavSections["DASHBOARD"] = "DASHBOARD";
    NavSections["SUPPORT"] = "SUPPORT";
})(NavSections || (NavSections = {}));
